import { designerServiceStores } from "@intrasync/designer";
import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Estimating Module Service Stores
 *
 * The manhole/designer service stores are sourced directly from the
 * `@intrasync/designer` package (`designerServiceStores`) so they stay in
 * sync automatically whenever the package is upgraded — see the package's
 * `config/serviceStores.ts` for the authoritative list.
 *
 * `user` is filtered out because the RootStore registers it as a built-in.
 * ServiceStore registration is idempotent (first registration wins — see
 * StoreRegistry.registerServiceStore), so deferring to the built-in keeps the
 * authoritative user config from being shadowed.
 */
const STORES_OWNED_BY_OTHER_MODULES = new Set<string>([
  "user", // registered as a built-in by RootStore
]);

/**
 * Estimating-only stores that the designer package does not (yet) declare.
 */
const estimatingOnlyStores: ServiceStoreConfig[] = [
  {
    name: "manhole-validations",
    options: {
      enableStorage: false,
      enableErrorNotifications: true,
      idField: "validationId",
    },
  },
  {
    name: "manhole-forms",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "formId",
    },
  },
  {
    name: "purchase-order-line-items",
    options: {
      enableStorage: true,
      enableErrorNotifications: true,
      idField: "formId",
    },
  },
];

export const estimatingStores: ServiceStoreConfig[] = [
  ...(designerServiceStores as unknown as ServiceStoreConfig[]).filter(
    (store) => !STORES_OWNED_BY_OTHER_MODULES.has(store.name),
  ),
  ...estimatingOnlyStores,
];
